module.exports = __webpack_public_path__ + "static/media/logo.a20571e0.png";